import { httpDelete, httpGet, httpPatch, httpPost } from "@/api/connection";
import {
  CreateTraceAccountFn,
  DeleteTraceAccountFn,
  GetTraceAccountsFn,
  GetTraceAccountsParams,
  UpdateTraceAccountFn,
} from "./traceAccounts.types";

const queryKey = ["trace-accounts", "list"];

const traceAccountsQueryKeys = {
  all: ["trace-accounts", "list"],
  list: (query?: GetTraceAccountsParams) => ["trace-accounts", "list", query],
  infiniteList: (query?: GetTraceAccountsParams) => [
    "trace-accounts",
    "infinite-list",
    query,
  ],
};

const get: GetTraceAccountsFn = async (values = {}) => {
  const { uuid, ...rest } = values;
  if (uuid) return httpGet(`/analysis/accounts/${uuid}`, rest);
  return httpGet("/analysis/accounts", rest);
};

const create: CreateTraceAccountFn = async (values) => {
  return httpPost("/analysis/accounts", values);
};

const update: UpdateTraceAccountFn = async (values) => {
  const { uuid, ...rest } = values;
  return httpPatch(`/analysis/accounts/${uuid}`, rest);
};

const remove: DeleteTraceAccountFn = async (values) => {
  const { uuid } = values;
  return httpDelete(`/analysis/accounts/${uuid}`);
};

const exportList = async (values = {}) => {
  return httpPost("/analysis/accounts/export", values);
};

const TraceAccountsAPI = {
  queryKey,
  queryKeys: traceAccountsQueryKeys,
  get,
  create,
  update,
  delete: remove,
  exportList,
};

export default TraceAccountsAPI;
